import React from 'react';
import { ProductItem } from '../../productItem/ProductItem';
import { useBestsellerProductsQuery } from '../ApiRequests';
import styles from './BestSellers.module.css';

export const BestSellers = () => {
    const bestsellersQuery = useBestsellerProductsQuery();

    if (bestsellersQuery.isLoading) {
        return <span>Loading...</span>
    }

    if (bestsellersQuery.isError) {
        return <span>Error: {bestsellersQuery.error.message}</span>
    }

    return (
        <section className={styles.bestsellersSection} >
            {
                bestsellersQuery.data.map((bestseller) => {
                    return (
                        <a href={`/Product/${bestseller.id}`} className={styles.bestsellerProduct} key={bestseller.id}>
                            <ProductItem
                                bestseller={false}
                                freeShipping={false}
                                id={bestseller.id}
                                imageSrc={bestseller.imageSrc}
                                name={bestseller.name} price={bestseller.price}
                                promotionPrice={bestseller.promotionPrice} />
                        </a>
                    );
                })
            }
        </section>
    );
}